import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff73c164&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ff73c164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff73c164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff73c164')) {
      api.createRecord('ff73c164', component.options)
    } else {
      api.reload('ff73c164', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff73c164&scoped=true&", function () {
      api.rerender('ff73c164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/conversion/index.vue"
export default component.exports